export default {"src":"/_next/static/media/ask_question.e6c9a890.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};